export default __webpack_public_path__ + "static/usps1-b38b7e148d442cac917ed754dbdb8b58.png";